module.exports = __webpack_public_path__ + "img/upload_file.d86ca7b4.svg";